<template>
	<v-form
		v-model="isValid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			align-center
			justify-center
		>
			<v-flex
				xs12
				sm9
				md8
				py-0
			>
				<v-text-field
					v-model="label"
					:rules="[
						validateCheckDuplicates(label, itemLabelsWithoutEditLabel),
						...validate.require,
						validate.max(label, 100)
					]"
					autofocus
					label="Option Label"
				/>
			</v-flex>
			<v-flex
				sm3
				md2
				class="text-xs-center"
			>
				<v-btn
					:disabled="!isValid"
					flat
					type="submit"
				>
					Submit
				</v-btn>
				<v-btn
					flat
					color="error"
					@click="close"
				>
					close
				</v-btn>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { CustomDataItem } from '@/models/CustomData';

export default {
	props: {
		customField: {
			type: Object,
			required: true,
		},
		item: {
			type: Object,
			default: null,
		},
	},
	
	mixins: [Validation],
	
	data() {
		return {
			label: '',
			itemLabelsWithoutEditLabel: [],
			isValid: true,
		};
	},
	
	computed: {
		itemLabels() {
			return this.customField.items.map(item => item.label);
		},
		
		isEdit() {
			return Boolean(this.item);
		},
	},
	
	watch: {
		item(itemToEdit) {
			this.label = '';
			this.itemLabelsWithoutEditLabel = this.itemLabels;
			if (itemToEdit) {
				this.label = itemToEdit.label;
				this.itemLabelsWithoutEditLabel = this.itemLabelsWithoutEditLabel.filter(item => item !== itemToEdit.label);
			}
		}
	},
	
	methods: {
		submit() {
			this.isValid = false;
			this.isEdit ? this.update() : this.create();
		},
		
		update() {
			const item = this.item;
			item.label = this.label;
			
			item.save().then(() => {
				this.$notify('success', `Option "${item.label}" has been updated.`);
			}).catch((e) => {
				dump(e);
				this.$notify('error', `Failed to update option "${item.label}".`);
			}).finally(() => {
				this.close();
			});
		},
		
		create() {
			const item = new CustomDataItem();
			item.parentId = this.customField.id;
			item.label = this.label;
			
			item.save().then(() => {
				this.$notify('success', `Option "${item.label}" has been created.`);
			}).catch((e) => {
				dump(e);
				this.$notify('error', `Failed to create option "${item.label}".`);
			}).finally(() => {
				this.close();
			});
		},
		
		close() {
			this.isValid = true;
			this.$emit('close');
		},
	},
}
</script>
